import Swiper from 'swiper/js/swiper';

let swiper;
let gallery;
const $window = $(window);
let videosInitialized = {};
let ytPlayer;

initGallery();

function initGallery() {
	gallery = document.querySelector('[data-gallery]');
	if (!gallery) return;

	initSwiper();
	initGalleryToggles();
	initGalleryClose();
	initVideos();
}


function initGalleryToggles() {
	const gallerytoggles = document.querySelectorAll('[data-gallery-toggle]');
	gallerytoggles.forEach((toggleItem) => {
		// get toggle data value
		let gotoIndex = null;
		if (toggleItem.dataset.galleryToggle) {
			gotoIndex = toggleItem.dataset.galleryToggle;
		}

		toggleItem.addEventListener('click', (event) => {

			gallery.classList.toggle('swiper-fullscreen-active');

			if (gotoIndex !== null) {
				swiper.slideTo(gotoIndex, false);
				swiper.lazy.loadInSlide(gotoIndex);
			}
		})
	});
}


function initGalleryClose() {
	const galleryclose = document.querySelectorAll('[data-gallery-close]');
	galleryclose.forEach((closeItem) => {
		closeItem.addEventListener('click', (event) => {
			closeGallery();
		})
	});

	// ESC to close
	$(document).keyup(function (e) {
		if (e.key === "Escape") { // escape key maps to keycode `27`
			closeGallery();
		}
	});
}


function initSwiper() {
	const pageHasSwiper = document.querySelectorAll('.swiper-container').length > 0;
	if (!pageHasSwiper) return;

	swiper = new Swiper('.swiper-container', {
		// Enable lazy loading
		initialSlide: 0,
		lazy: true,
		watchSlidesVisibility: true,
		preloadImages: false,
		observer: true,
		observeParents: true,
		observeSlideChildren: true,
		slideToClickedSlide: false,
		preventClicks: false,
		preventClicksPropagation: false,
		pagination: {
			el: '.swiper-pagination',
			type: 'fraction',
		},
		keyboard: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		on: {

			slideChange: function() {
				stopVideo(); // stop current video

				const currentSlide = this.slides[this.activeIndex];
				const videoContainer = currentSlide.querySelector('.video-container');

				if (videoContainer) {
					ytPlayer = initVideo(videoContainer);
				} else {
					ytPlayer = null;
				}

			}
		},

	});
	swiper.init();
}

function stopVideo(videoContainer) {
	if (ytPlayer) {
		ytPlayer.pauseVideo();
	}
}


function closeGallery() {
	if (!gallery.classList.contains('swiper-fullscreen-active')) {
		return;
	}
	stopVideo(document.querySelector('.swiper-slide-active .video-container'));
	gallery.classList.remove('swiper-fullscreen-active');
}


function initVideos() {
	var tag = document.createElement('script');
	tag.src = "https://www.youtube.com/iframe_api";
	var firstScriptTag = document.getElementsByTagName('script')[0];
	firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

	// prevent youtube Iframe catch focus
	$window.on("blur.video-iframe", function () {
		setTimeout(function () {
			$(window).focus();
		}, 500);
	});

	$window.on('keydown', function(e) {
		if (ytPlayer) {
			const state = ytPlayer.getPlayerState();
			switch (e.which) {
				case 37: // left
					ytPlayer.seekTo(ytPlayer.getCurrentTime() - 5, true);
					break;
				case 39: // right
					ytPlayer.seekTo(ytPlayer.getCurrentTime() + 5, true);
					break;
				case 32:
					if (state === 1) {
						ytPlayer.pauseVideo();
					} else {
						ytPlayer.playVideo();
					}
			}
		}
	});

}


function initVideo(element, callback) {
	const videoId = element.dataset.id;
	if (videosInitialized[videoId]) {
		return videosInitialized[videoId];
	}
	const player = element.querySelector('.video-iframe');

	const options = {
		playerVars: {
			'autoplay': 0,
			'modestbranding': 1,
			'controls': 1,
			'rel': 0,
			'enablejsapi': 1,
			'origin': '*',
		},
		videoId,
	};

	return videosInitialized[videoId] = new YT.Player(player, options);
}
